import { render } from "./Administratie.vue?vue&type=template&id=1550935c&scoped=true"
import script from "./Administratie.vue?vue&type=script&lang=js"
export * from "./Administratie.vue?vue&type=script&lang=js"

import "./Administratie.vue?vue&type=style&index=0&id=1550935c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1550935c"]])

export default __exports__